module.exports = __webpack_public_path__ + "img/full3-min.6dd3f1a5.png";